import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const populateCareer = (code) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/career/getByCode/' + code)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getRelatedCareers = (code) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/career/relatedCareers/' + code)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const populateCareerResult = (careerCode, locationParam) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/career/emsi/' + careerCode + '?levelAndGeoIds=' + locationParam)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const populateCareerByCodeAndSource = (code, source) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/career/getByCode/' + code + '?source=' + source)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const populateGeoIds = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/majorMinor/countyMsaStateList')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareers = (page, count, name) => {
  if (!page || page < 0) {
    page = 0
  }
  // TODO change endpoint once created
  let url = '/career/findAll?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareerForProfile = (page, count, name, type) => {
  if (!page || page < 0) {
    page = 0
  }
  // TODO change endpoint once created
  let url = '/career/profile?page=' + page
  if (count >= 0) {
    url = url + '&count=' + count
  }
  if (name) {
    url = url + '&name=' + name
  }
  if (type) {
    url = url + '&type=' + type
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}
export const getCareerByCode = (code) => {
  return getItem('token').then(token => {
    return HTTP(token).get('career/findByCode/' + code)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getLearnerExploreCareers = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/career/learnerExploreCareers')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/career/api.js